<template>
	<div class="transbankResult">
		<div v-if="status == null" class="alert alert-info">
			<div class="spinner-border spinner-border-sm" role="status">
				<span class="visually-hidden">Confirmando...</span>
			</div>
			Estamos confirmando la transacción, espere un momento . . .
		</div>
		<div v-else>
			<div v-if="status == 'ABORTED'" class="alert alert-warning">
				Has anulado la transacción o ha ocurrido algún un Error en Transbank. 
				<router-link class="text-link pointer" :to="(order != null) ? '/subscription/' + order.token : '/subscriptions'">
					<span v-if="order != null">
						Ir a la suscripción
					</span>
					<span v-else>
						Volver a suscripciones
					</span>
				</router-link>
			</div>
			<div v-if="status == 'FAILED'" class="alert alert-danger">
				No se completo la transacción, algo a salido mal. 
				<router-link class="text-link pointer" :to="(order != null) ? '/subscription/' + order.token : '/subscriptions'">
					<span v-if="order != null">
						Ir a la suscripción
					</span>
					<span v-else>
						Volver a suscripciones
					</span>
				</router-link>
			</div>
			<div v-if="status == 'AUTHORIZED'">
				<div class="card border border-success">
					<div class="card-body text-secondary p-5">
						<h3 class="text-entity">Gracias por suscribirse!</h3>
						<div class="alert alert-info" role="alert" v-if="order != null && order.client_sendto != null && order.client_sendto.email != null && order.client_sendto.email != ''">
							Hemos enviado un email con la información de su suscripción a: <a class="alert-link" :href="'mailto:' + order.client_sendto.email">{{order.client_sendto.email}}</a>
						</div>
						<div class="row">
							<div class="col-sm-6" v-if="orderTransbankResultOutput != null">
								<h4>Información de Pago:</h4>
								<ul>
									<li><h5>Webpay Plus</h5></li>
									<li>Tipo de transacción: <span class="fw-semibold">Suscripción,</span></li>
									<li>Resultado: <span class="fw-semibold">Transacción Aprobada,</span></li>
									<li>Nº Orden Webpay: <span class="fw-semibold">{{orderTransbankResultOutput.buyOrder}}</span></li>
									<li>Fecha: <span class="fw-semibold">{{transactionDate}}</span></li>
									<li>Ultimos 4 nums. de Tarjeta: <span class="fw-semibold">...{{orderTransbankResultOutput.cardDetail_cardNumber}}</span></li>
									<li>Código Autorización: <span class="fw-semibold">{{orderTransbankResultOutput.detailOutput_authorizationCode}}</span></li>
									<li>Tipo de Pago: <span class="fw-semibold">{{detailOutputPaymentTypeCode}}</span></li>
									<li>Tipo de Cuotas: <span class="fw-semibold">{{typeShares}}</span></li>
									<li>Numero de Cuotas: <span class="fw-semibold">{{orderTransbankResultOutput.detailOutput_sharesNumber}}</span></li>
								</ul>
							</div>
							<div class="col-sm-6">
								<h4>Tu suscripción será enviada a:</h4>
								<div v-if="order != null">
									<div>
										<svg class="text-secondary me-2" width="14" height="14"><use xlink:href="#person-badge"/></svg>
										<span class="fw-semibold align-middle text-secondary">
											<span v-if="order.church.client != null">
												{{ order.church.client.name }} {{ order.church.client.surname }}
											</span>
											<span v-else class="text-danger">
												Esta Iglesia no tiene un CPIL asignado
											</span>
										</span>
									</div>
									<div class="list-group-light p-0">
										<div class="list-group-item d-flex justify-content-between align-items-center mb-1">
											<div>
												<div class="fw-semibold align-middle text-secondary">
													<svg class="text-secondary me-1" width="14" height="14"><use xlink:href="#building"/></svg>
													{{ order.church.type_church.name }} {{ order.church.name }}
												</div>
												<div class="ms-4 text-secondary">Distrito: {{ order.church.district.name }} ({{ order.church.entity.synthetic }})</div>
											</div>
										</div>
									</div>
								</div>
								<br>
							</div>
						</div>
						<div class="text-end">
							<router-link class="text-link pointer" :to="(typePayment == 'ORD') ? '/subscription/' + order.token : '/subscriptions'">
								<span v-if="typePayment == 'ORD'">
									Ir a la suscripción
								</span>
								<span v-else>
									Ver suscripciones
								</span>
							</router-link>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import mixin from '@/mixins'
	import axiosSystem from '@/mixins/axiosSystem.js'
	import transbank from '@/mixins/transbank.js'

	export default {
		name: 'TransbankResult',
		mixins: [mixin, axiosSystem, transbank],
		props: ['action', 'token'],
		data() {
			return {
				status: null,
				legalDocuments: [],
				orderTransbankResultOutput: {
					order_id: 476,
					buyOrder: "ORD-476",
					accountingDate: "0707",
					cardDetail_cardNumber: "6623",
					detailOutput_authorizationCode: "1213",
					detailOutput_paymentTypeCode: "NC",
					detailOutput_responseCode: 0,
					detailOutput_sharesNumber: 8,
					detailOutput_amount: 99400,
					detailOutput_commerceCode: 597032778690,
					detailOutput_buyOrder: "ORD-476",
					sessionId: "120136109",
					transactionDate: "2022-07-07T16:25:02.163Z",
					urlRedirection: null,
					VCI: "TSY",
					token: "01ab087ac0f37fc698d999eef956fefa2914f68eb0b46cfbe8f07396caef59a5",
					updated_at: "2022-07-07T16:25:32.000000Z",
					created_at: "2022-07-07T16:25:32.000000Z",
					id: 30
				},
				order: {
					church: {
						name: 'Conquil',
						district: {
							name: 'Villarrica'
						},
						entity: {
							name: 'Asociación Sur Austral de Chile',
							synthetic: 'ASACh'
						},
						client: {
							name: 'Denisse',
							surname: 'Castillo'
						},
						type_church: {
							name: 'Iglesia'
						}
					},
					client_sendto: {
						email: 'italo1.navarrete@editorialaces.com'
					},
					token: '609230e8800f19702f0a490b4febf9f4'
				}
			}
		},
		components: {
		},
		computed: {
			transactionDate() {
				if(this.orderTransbankResultOutput != null) {
					let ar = this.orderTransbankResultOutput.transactionDate.split('T')
					return ar[0] + ' ' + ar[1].substring(0,5)
				}
				return 'Sin definir'
			},
			detailOutputPaymentTypeCode() {
				if(this.orderTransbankResultOutput != null) {
					switch (this.orderTransbankResultOutput.detailOutput_paymentTypeCode) {
						case 'VD':
							return 'Venta Débito'
						case 'VN':
							return 'Venta Normal'
						case 'VC':
							return 'Venta en cuotas'
						case 'SI':
							return '3 cuotas sin interés'
						case 'S2':
							return '2 cuotas sin interés'
						case 'NC':
							return this.orderTransbankResultOutput.detailOutput_sharesNumber + ' Cuotas sin interés'
						case 'VP':
							return 'Venta Prepago'
						default:
							return 'Sin definir'
					}
				}
				return 'Sin definir'
			},
			typeShares() {
				if(this.orderTransbankResultOutput != null) {
					if(this.orderTransbankResultOutput.detailOutput_paymentTypeCode == 'VD')
						return 'Sin Cuotas'
					else
						return 'Credito'
				}
				return 'Sin definir'
			},
			typePayment() {
				if(this.orderTransbankResultOutput != null) {
					return this.orderTransbankResultOutput.buyOrder.split('-')[0]
				}
				return 'SIN'
			}
		},
		methods: {
			initModuleLocal() {
				document.title = 'Resultado Pago Transbank - Suscripción ACES Chile'
				this.commit(this.token, this.action)
			},
			commitTransbankResultLocal(response) {
				if(response.data.success == true) {
					this.status = response.data.data.transbankToken.status
					this.orderTransbankResultOutput = response.data.data.orderTransbankResultOutput
					this.order = response.data.data.order
					this.legalDocuments = response.data.data.legalDocuments
				}
			},
			commitTransbankResultErrorLocal(error) {
				//this.$router.push('/')
			},
			axiosError(error) {
				//this.$router.push('/')
			}
		},
		mounted () {
			this.initModule()
		}
	}
</script>
